import {
    ArrivalMarker, BikeMarker,
    CarParkingMarker,
    CollectionMarker,
    DepartureMarker,
    DepositMarker, LodgingMarker, StepMarker
} from "../../../../booking/components/map/leaflet/Marker";
import {GeoJSON, Polyline, Popup} from "react-leaflet";
import React from "react";
import {isEmpty} from "lodash";

export function CarParking({departure}) {
    return <>
        {departure.step && <CarParkingMarker position={[departure.step.latitude, departure.step.longitude]}>
            <Popup>
                Stationnement
            </Popup>
        </CarParkingMarker>}
    </>
}

export function CarTransport({departure, arrival}) {
    return <>
        {departure.step && <CollectionMarker position={[departure.step.latitude, departure.step.longitude]}>
            <Popup>
                Prise en charge du véhicule
            </Popup>
        </CollectionMarker>}
        {arrival.step && <DepositMarker position={[arrival.step.latitude, arrival.step.longitude]}>
            <Popup>
                Dépôt du véhicule
            </Popup>
        </DepositMarker>}
        {departure.step && arrival.step &&
            <Polyline pathOptions={{color: '#c35222'}}
                      positions={[[departure.step.latitude, departure.step.longitude], [arrival.step.latitude, arrival.step.longitude]]}>
                <Popup>Convoyage de "{departure.step.title}" à "{arrival.step.title}"</Popup>
            </Polyline>}
    </>
}

export function BikeTransport({departure, arrival}) {
    return <>
        {departure.step && <BikeMarker position={[departure.step.latitude, departure.step.longitude]}>
            <Popup>
                Prise en charge de vélo(s)
            </Popup>
        </BikeMarker>}
        {arrival.step && <BikeMarker position={[arrival.step.latitude, arrival.step.longitude]}>
            <Popup>
                Dépôt du vélo
            </Popup>
        </BikeMarker>}
        {departure.step && arrival.step &&
            <Polyline pathOptions={{color: '#c35222'}}
                      positions={[[departure.step.latitude, departure.step.longitude], [arrival.step.latitude, arrival.step.longitude]]}>
                <Popup>Transport de vélo(s) de "{departure.step.title}" à "{arrival.step.title}"</Popup>
            </Polyline>}
    </>
}
export function PeopleTransport({departure, arrival}) {
    return <>
        {departure.step &&
            <DepartureMarker position={[departure.step.latitude, departure.step.longitude]}>
                <Popup>
                    Départ transport sur mesure
                </Popup>
            </DepartureMarker>}
        {arrival.step &&
            <ArrivalMarker position={[arrival.step.latitude, arrival.step.longitude]}>
                <Popup>
                    Arrivée transport sur mesure
                </Popup>
            </ArrivalMarker>}
        {departure.step && arrival.step &&
            <Polyline pathOptions={{color: '#c35222'}}
                      positions={[[departure.step.latitude, departure.step.longitude], [arrival.step.latitude, arrival.step.longitude]]}>
                <Popup>Transport sur mesure de "{departure.step.title}" à "{arrival.step.title}"</Popup>
            </Polyline>}
    </>
}

export function RegularShuttle({departure, arrival}) {
    return <>
        {departure.step &&
            <DepartureMarker position={[departure.step.latitude, departure.step.longitude]}>
                <Popup>
                    Départ navette
                </Popup>
            </DepartureMarker>}
        {arrival.step &&
            <ArrivalMarker position={[arrival.step.latitude, arrival.step.longitude]}>
                <Popup>
                    Arrivée navette
                </Popup>
            </ArrivalMarker>}
        {departure.step && arrival.step &&
            <Polyline pathOptions={{color: '#c35222'}}
                      positions={[[departure.step.latitude, departure.step.longitude], [arrival.step.latitude, arrival.step.longitude]]}>
                <Popup>Navette de "{departure.step.title}" à "{arrival.step.title}"</Popup>
            </Polyline>}
    </>
}

export function BagTransport({departure, arrival, geoJson, stops, steps}) {
    return <>
        {steps && steps
            .filter(step => (!departure.step || step.id != departure.step.id) && (!arrival.step || step.id != arrival.step.id))
            .map(step => <StepMarker key={step.id} position={[step.latitude, step.longitude]}>
                <Popup>
                    <p>{step.title}</p>
                </Popup>
            </StepMarker>)
        }

        {stops && stops.map(stop => <LodgingMarker selectedColor={stop.updateStatus != null ? '#FF7B1DFF' : '#454fc8'} selected={true} key={stop.id}
                                                   position={[stop.latitude, stop.longitude]}>
            <Popup>
                <p>{stop.title}<br/> {stop.address}</p>
            </Popup>
        </LodgingMarker>)}
        {geoJson &&
            <GeoJSON key={`${departure.step.id} - ${arrival.step.id}`} pathOptions={{color: '#ff8246'}}
                     data={{features: geoJson}}
                     eventHandlers={{
                         mouseover: (e) => e.target.setStyle({opacity: 0.8, weight: 5}),
                         mouseout: (e) => e.target.setStyle({opacity: 1, weight: 3})
                     }}
            ><Popup>
                Transport de bagages de "{departure.step.title}" à "{arrival.step.title}"
            </Popup></GeoJSON>}
        {departure.step &&
            <DepartureMarker position={[departure.step.latitude, departure.step.longitude]}>
                <Popup>
                    Départ
                </Popup>
            </DepartureMarker>}
        {!isEmpty(departure.stop) && <LodgingMarker selectedColor={departure.stop.updateStatus != null ? '#FF7B1DFF' : '#454fc8'} selected={true} key={departure.stop.id}
                                          position={[departure.stop.latitude, departure.stop.longitude]}>
            <Popup>
                <p>{departure.stop.title}<br/> {departure.stop.address}</p>
            </Popup>
        </LodgingMarker>}
        {arrival.step &&
            <ArrivalMarker position={[arrival.step.latitude, arrival.step.longitude]}>
                <Popup>
                    Arrivée
                </Popup>
            </ArrivalMarker>}
        {!isEmpty(arrival.stop) && <LodgingMarker selectedColor={arrival.stop.updateStatus != null ? '#FF7B1DFF' : '#454fc8'} selected={true} key={arrival.stop.id}
                                        position={[arrival.stop.latitude, arrival.stop.longitude]}>
            <Popup>
                <p>{arrival.stop.title}<br/> {arrival.stop.address}</p>
            </Popup>
        </LodgingMarker>}
    </>
}